import { InputNumber, Select } from 'antd';
import React from 'react';
const Option = Select.Option;

const MA_OPTIONS = [
    <Option key={0} value={0}>
        SMA
    </Option>,
    <Option key={1} value={1}>
        EMA
    </Option>,
    <Option key={2} value={2}>
        WMA
    </Option>,
    <Option key={3} value={3}>
        DEMA
    </Option>,
    <Option key={4} value={4}>
        TEMA
    </Option>,
    <Option key={5} value={5}>
        TRIMA
    </Option>,
    <Option key={6} value={6}>
        KAMA
    </Option>,
    <Option key={7} value={7}>
        MAMA
    </Option>,
    <Option key={8} value={8}>
        T3
    </Option>
];

const SOURCE_OPTIONS = [
    <Option key={'open'} value={'open'}>
        Open
    </Option>,
    <Option key={'high'} value={'high'}>
        High
    </Option>,
    <Option key={'low'} value={'low'}>
        Low
    </Option>,
    <Option key={'close'} value={'close'}>
        Close
    </Option>
];

export const Indicators = {
    PERCENTCHANGE: {
        name: 'Percent change',
        group: 'Overlap',
        inputs: [],
        outputs: [
            {
                name: 'change',
                label: 'Change %'
            }
        ]
    },
    ICHIMOKU: {
        name: 'Ichimoku Cloud',
        group: 'Overlap',
        defaults: {},
        inputs: [
            {
                name: 'conversionPeriod',
                label: 'Conversion Period',
                default: 9,
                component: InputNumber
            },
            {
                name: 'basePeriod',
                label: 'Base Period',
                default: 26,
                component: InputNumber
            },
            {
                name: 'spanPeriod',
                label: 'Span Period',
                default: 52,
                component: InputNumber
            },
            {
                name: 'displacement',
                label: 'Displacement',
                default: 26,
                component: InputNumber
            }
        ],
        outputs: [
            {
                name: 'conversion',
                label: 'Conversion (Tenkan-sen)'
            },
            {
                name: 'base',
                label: 'Base (Kijun-sen)'
            },
            {
                name: 'spanA',
                label: 'spanA (Senkou Span A)'
            },
            {
                name: 'spanB',
                label: 'spanB (Senkou Span B)'
            }
        ]
    },
    WAVETREND: {
        name: 'Wave Trend',
        group: 'Overlap',
        isApexCustom: true,
        defaults: {},
        inputs: [
            {
                name: 'channelLen',
                label: 'Channel Length',
                default: 10,
                component: InputNumber
            },
            {
                name: 'maLen',
                label: 'Moving Average Length',
                default: 3,
                component: InputNumber
            },
            {
                name: 'smoothLen',
                label: 'Smoothing Average Length',
                default: 3,
                component: InputNumber
            }
        ],
        outputs: [
            {
                name: 'slow',
                label: 'Slow'
            },
            {
                name: 'fast',
                label: 'Fast'
            }
        ]
    },
    CHANDELIER_EXIT: {
        name: 'Chandelier Exit',
        group: 'Stop Loss',
        isApexCustom: true,
        defaults: {},
        inputs: [
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                default: 14,
                component: InputNumber
            },
            {
                name: 'multiplier',
                label: 'Multiplier',
                default: 3,
                component: InputNumber
            }
        ],
        outputs: [
            {
                name: 'trend',
                label: 'Trend'
            },
            {
                name: 'stop',
                label: 'Stop Loss'
            },
            {
                name: 'trendChange',
                label: 'Trend Change'
            }
        ]
    },

    ATRSTOP: {
        name: 'ATR Stop',
        group: 'Stop Loss',
        isApexCustom: true,
        defaults: {},
        inputs: [
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                default: 14,
                component: InputNumber
            },
            {
                name: 'multiplier',
                label: 'Multiplier',
                default: 3,
                component: InputNumber
            }
        ],
        outputs: [
            {
                name: 'sentiment',
                label: 'Sentiment'
            },
            {
                name: 'stopLoss',
                label: 'Stop Loss'
            }
        ]
    },
    BBANDSWIDTH: {
        name: 'Bollinger Bands Width',
        group: 'Overlap',
        defaults: {
            source: 'close',
            optInTimePeriod: 20
        },
        inputs: [
            {
                name: 'source',
                label: 'Source',
                component: Select,
                options: SOURCE_OPTIONS
            },
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                component: InputNumber
            },
            {
                name: 'optInNbDevUp',
                label: 'Deviations up',
                default: 2,
                component: InputNumber
            },
            {
                name: 'optInNbDevDn',
                label: 'Deviations down',
                default: 2,
                component: InputNumber
            },
            {
                name: 'optInMAType',
                label: 'MA Type',
                default: 0,
                component: Select,
                options: MA_OPTIONS
            }
        ],
        outputs: [
            {
                name: 'width',
                label: 'Width'
            }
        ]
    },
    ROC: {
        name: 'Rate of change',
        group: 'Momentum',
        defaults: {
            source: 'close',
            optInTimePeriod: 10
        },
        inputs: [
            {
                name: 'source',
                label: 'Source',
                component: Select,
                options: SOURCE_OPTIONS
            },
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                component: InputNumber
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },
    ROCP: {
        name: 'Rate of change Percentage',
        group: 'Momentum',
        defaults: {
            source: 'close',
            optInTimePeriod: 10
        },
        inputs: [
            {
                name: 'source',
                label: 'Source',
                component: Select,
                options: SOURCE_OPTIONS
            },
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                component: InputNumber
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },
    BBANDSWIDTHPERCENT: {
        name: 'Bollinger Bands %B',
        group: 'Overlap',
        defaults: {
            source: 'close',
            optInTimePeriod: 20
        },
        inputs: [
            {
                name: 'source',
                label: 'Source',
                default: 'close',
                component: Select,
                options: SOURCE_OPTIONS
            },
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                component: InputNumber
            },
            {
                name: 'optInNbDevUp',
                label: 'Deviations up',
                default: 2,
                component: InputNumber
            },
            {
                name: 'optInNbDevDn',
                label: 'Deviations down',
                default: 2,
                component: InputNumber
            },
            {
                name: 'optInMAType',
                label: 'MA Type',
                default: 0,
                component: Select,
                options: MA_OPTIONS
            }
        ],
        outputs: [
            {
                name: 'percent',
                label: 'Percent'
            }
        ]
    },
    AVGPRICE: {
        name: 'Average Price',
        group: 'Price',
        defaults: {},
        inputs: [],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },
    ADOSC: {
        name: 'Chaikin A/D Oscillator',
        group: 'Volume',
        defaults: {},
        inputs: [
            {
                name: 'optInFastPeriod',
                label: 'Fast Period',
                default: 3,
                component: InputNumber
            },
            {
                name: 'optInSlowPeriod',
                label: 'Slow Period',
                default: 10,
                component: InputNumber
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },
    ADX: {
        name: 'ADX',
        group: 'Momentum',
        inputs: [
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                default: 14,
                component: InputNumber
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },
    ADXR: {
        name: 'ADX Rating',
        group: 'Momentum',
        inputs: [
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                default: 14,
                component: InputNumber
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },
    APO: {
        name: 'Absolute Price Oscillator',
        group: 'Momentum',
        defaults: {
            source: 'close'
        },
        inputs: [
            {
                name: 'source',
                label: 'Source',
                default: 'close',
                component: Select,
                options: SOURCE_OPTIONS
            },
            {
                name: 'optInFastPeriod',
                label: 'Fast Period',
                default: 12,
                component: InputNumber
            },
            {
                name: 'optInSlowPeriod',
                label: 'Slow Period',
                default: 26,
                component: InputNumber
            },
            {
                name: 'optInMAType',
                label: 'MA Type',
                default: 0,
                component: Select,
                options: MA_OPTIONS
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },
    ATR: {
        name: 'Average True Range',
        group: 'Volatility',
        inputs: [
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                default: 14,
                component: InputNumber
            },
            {
                name: 'multiplier',
                label: 'Multiplier',
                default: 1,
                component: InputNumber
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },
    NATR: {
        name: 'Normalized Average True Range',
        group: 'Volatility',
        inputs: [
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                default: 14,
                component: InputNumber
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },
    AROON: {
        name: 'Aroon',
        group: 'Momentum',
        inputs: [
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                default: 14,
                component: InputNumber
            }
        ],
        outputs: [
            {
                name: 'outAroonDown',
                label: 'Down'
            },
            {
                name: 'outAroonUp',
                label: 'Up'
            }
        ]
    },
    AROONOSC: {
        name: 'Aroon Oscillator',
        group: 'Momentum',
        inputs: [
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                default: 14,
                component: InputNumber
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },
    BBANDS: {
        name: 'Bollinger Bands',
        group: 'Overlap',
        defaults: {
            source: 'close',
            optInTimePeriod: 20
        },
        inputs: [
            {
                name: 'source',
                label: 'Source',
                default: 'close',
                component: Select,
                options: SOURCE_OPTIONS
            },
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                component: InputNumber
            },
            {
                name: 'optInNbDevUp',
                label: 'Deviations up',
                default: 2,
                component: InputNumber
            },
            {
                name: 'optInNbDevDn',
                label: 'Deviations down',
                default: 2,
                component: InputNumber
            },
            {
                name: 'optInMAType',
                label: 'MA Type',
                default: 0,
                component: Select,
                options: MA_OPTIONS
            }
        ],
        outputs: [
            {
                name: 'outRealUpperBand',
                label: 'Upper Band'
            },
            {
                name: 'outRealMiddleBand',
                label: 'Middle Band'
            },
            {
                name: 'outRealLowerBand',
                label: 'Lower Band'
            }
        ]
    },
    CCI: {
        name: 'Commodity Channel Index',
        group: 'Momentum',
        inputs: [
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                default: 14,
                component: InputNumber
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },
    CMO: {
        name: 'Chande Momentum Oscillator',
        group: 'Momentum',
        defaults: {
            source: 'close'
        },
        inputs: [
            {
                name: 'source',
                label: 'Source',
                default: 'close',
                component: Select,
                options: SOURCE_OPTIONS
            },
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                component: InputNumber,
                default: 14
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },
    DEMA: {
        name: 'DEMA',
        group: 'Overlap',
        defaults: {
            source: 'close'
        },
        inputs: [
            {
                name: 'source',
                label: 'Source',
                default: 'close',
                component: Select,
                options: SOURCE_OPTIONS
            },
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                component: InputNumber,
                default: 30
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },
    EMA: {
        name: 'EMA',
        group: 'Overlap',
        defaults: {
            source: 'close'
        },
        inputs: [
            {
                name: 'source',
                label: 'Source',
                default: 'close',
                component: Select,
                options: SOURCE_OPTIONS
            },
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                component: InputNumber,
                default: 30
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },
    KAMA: {
        name: 'Kaufman Adaptive Moving Average',
        group: 'Overlap',
        defaults: {
            source: 'close'
        },
        inputs: [
            {
                name: 'source',
                label: 'Source',
                default: 'close',
                component: Select,
                options: SOURCE_OPTIONS
            },
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                component: InputNumber,
                default: 30
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },
    RSI: {
        name: 'Relative Strength Index',
        group: 'Momentum',
        defaults: {
            source: 'close'
        },
        inputs: [
            {
                name: 'source',
                label: 'Source',
                default: 'close',
                component: Select,
                options: SOURCE_OPTIONS
            },
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                default: 14,
                component: InputNumber
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },
    LINEARREG: {
        name: 'Linear Regression',
        group: 'Statistic',
        defaults: {
            source: 'close'
        },
        inputs: [
            {
                name: 'source',
                label: 'Source',
                default: 'close',
                component: Select,
                options: SOURCE_OPTIONS
            },
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                default: 14,
                component: InputNumber
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },
    LINEARREG_ANGLE: {
        name: 'Linear Regression Angle',
        group: 'Statistic',
        defaults: {
            source: 'close'
        },
        inputs: [
            {
                name: 'source',
                label: 'Source',
                default: 'close',
                component: Select,
                options: SOURCE_OPTIONS
            },
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                default: 14,
                component: InputNumber
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },

    MACD: {
        name: 'MACD',
        group: 'Momentum',
        defaults: {
            source: 'close'
        },
        inputs: [
            {
                name: 'source',
                label: 'Source',
                default: 'close',
                component: Select,
                options: SOURCE_OPTIONS
            },
            {
                name: 'optInFastPeriod',
                label: 'Fast Period',
                component: InputNumber,
                default: 12
            },
            {
                name: 'optInSlowPeriod',
                label: 'Slow Period',
                component: InputNumber,
                default: 26
            },
            {
                name: 'optInSignalPeriod',
                label: 'Signal Period',
                component: InputNumber,
                default: 9
            }
        ],
        outputs: [
            {
                name: 'outMACD',
                label: 'MACD'
            },
            {
                name: 'outMACDSignal',
                label: 'Signal'
            },
            {
                name: 'outMACDHist',
                label: 'Histogram'
            }
        ]
    },
    MAMA: {
        name: 'MAMA',
        group: 'Overlap',
        defaults: {
            source: 'close'
        },
        inputs: [
            {
                name: 'source',
                label: 'Source',
                default: 'close',
                component: Select,
                options: SOURCE_OPTIONS
            },
            {
                name: 'optInFastLimit',
                label: 'Fast Limit',
                component: InputNumber,
                default: 0.5
            },
            {
                name: 'optInSlowLimit',
                label: 'Slow Limit',
                component: InputNumber,
                default: 0.05
            }
        ],
        outputs: [
            {
                name: 'outMAMA',
                label: 'MAMA'
            },
            {
                name: 'outFAMA',
                label: 'FAMA'
            }
        ]
    },
    MFI: {
        name: 'Money Flow Index',
        group: 'Momentum',
        inputs: [
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                component: InputNumber,
                default: 14
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },
    MOM: {
        name: 'Momentum',
        group: 'Momentum',
        defaults: {
            source: 'close'
        },
        inputs: [
            {
                name: 'source',
                label: 'Source',
                default: 'close',
                component: Select,
                options: SOURCE_OPTIONS
            },
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                component: InputNumber,
                default: 10
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },
    OBV: {
        name: 'On Balance Volume',
        group: 'Volume',
        defaults: {
            source: 'close'
        },
        inputs: [],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },

    VWAP: {
        name: 'Volume Weighted Average Price',
        group: 'Overlap',
        defaultPeriod: '1d',
        disablePeriod: false,
        inputs: [],
        outputs: [
            {
                name: 'value',
                label: 'Value'
            }
        ]
    },

    PLUS_DI: {
        name: 'Plus Directional Indicator',
        group: 'Momentum',
        inputs: [
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                component: InputNumber,
                default: 14
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },

    MINUS_DI: {
        name: 'Minus Directional Indicator',
        group: 'Momentum',
        inputs: [
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                component: InputNumber,
                default: 14
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },
    SAR: {
        name: 'Parabolic SAR',
        group: 'Overlap',
        inputs: [
            {
                name: 'optInAcceleration',
                label: 'Acceleration Factor',
                component: InputNumber,
                default: 0.02
            },
            {
                name: 'optInMaximum',
                label: 'AF Maximum',
                component: InputNumber,
                default: 0.2
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },

    STOCH: {
        name: 'Stochastic',
        group: 'Momentum',
        inputs: [
            {
                name: 'optInFastK_Period',
                label: 'Fast-K Period',
                component: InputNumber,
                default: 5
            },
            {
                name: 'optInSlowD_Period',
                label: 'Slow-D Period',
                component: InputNumber,
                default: 3
            },
            {
                name: 'smoothLen',
                label: 'Smooth Length',
                default: 3,
                component: InputNumber
            }
        ],
        outputs: [
            {
                name: 'outSlowK',
                label: 'K'
            },
            {
                name: 'outSlowD',
                label: 'D'
            }
        ]
    },
    STOCHRSI: {
        name: 'Stochastic RSI',
        group: 'Momentum',
        defaults: {
            source: 'close'
        },
        inputs: [
            {
                name: 'source',
                label: 'Source',
                default: 'close',
                component: Select,
                options: SOURCE_OPTIONS
            },
            {
                name: 'optInTimePeriod',
                label: 'RSI Time Period (Length)',
                component: InputNumber,
                default: 14
            },
            {
                name: 'stochTimePeriod',
                label: 'Stoch Time Period (Length)',
                component: InputNumber,
                default: 14
            },
            {
                name: 'optInFastK_Period',
                label: 'Fast-K Period',
                component: InputNumber,
                default: 3
            },
            {
                name: 'optInFastD_Period',
                label: 'Fast-D Period',
                component: InputNumber,
                default: 3
            }
        ],
        outputs: [
            {
                name: 'outFastK',
                label: 'K'
            },
            {
                name: 'outFastD',
                label: 'D'
            }
        ]
    },
    STDDEV: {
        name: 'Standard Deviation',
        group: 'Statistic',
        defaults: {
            source: 'close'
        },
        inputs: [
            {
                name: 'source',
                label: 'Source',
                default: 'close',
                component: Select,
                options: SOURCE_OPTIONS
            },
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                component: InputNumber,
                default: 5
            },
            {
                name: 'optInNbDev',
                label: 'Deviations',
                component: InputNumber,
                default: 2
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },
    SMA: {
        name: 'Simple Moving Average',
        group: 'Overlap',
        defaults: {
            source: 'close'
        },
        inputs: [
            {
                name: 'source',
                label: 'Source',
                default: 'close',
                component: Select,
                options: SOURCE_OPTIONS
            },
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                component: InputNumber,
                default: 30
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },
    WMA: {
        name: 'WMA',
        group: 'Overlap',
        defaults: {
            source: 'close'
        },
        inputs: [
            {
                name: 'source',
                label: 'Source',
                default: 'close',
                component: Select,
                options: SOURCE_OPTIONS
            },
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                component: InputNumber,
                default: 30
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },
    T3: {
        name: 'Tilson Moving average (T3)',
        group: 'Overlap',
        defaults: {
            source: 'close'
        },
        inputs: [
            {
                name: 'source',
                label: 'Source',
                default: 'close',
                component: Select,
                options: SOURCE_OPTIONS
            },
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                component: InputNumber,
                default: 5
            },
            {
                name: 'optInVFactor',
                label: 'Volume Factor',
                component: InputNumber,
                default: 0.7
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },
    TEMA: {
        name: 'Triple Exponential Moving Average',
        group: 'Overlap',
        defaults: {
            source: 'close'
        },
        inputs: [
            {
                name: 'source',
                label: 'Source',
                default: 'close',
                component: Select,
                options: SOURCE_OPTIONS
            },
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                component: InputNumber,
                default: 30
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },
    TRIMA: {
        name: 'Triangular Moving Average',
        group: 'Overlap',
        defaults: {
            source: 'close'
        },
        inputs: [
            {
                name: 'source',
                label: 'Source',
                default: 'close',
                component: Select,
                options: SOURCE_OPTIONS
            },
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                component: InputNumber,
                default: 30
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },
    TSF: {
        name: 'Time Series Forecast',
        group: 'Statistic',
        defaults: {
            source: 'close'
        },
        inputs: [
            {
                name: 'source',
                label: 'Source',
                default: 'close',
                component: Select,
                options: SOURCE_OPTIONS
            },
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                component: InputNumber,
                default: 14
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },
    ULTOSC: {
        name: 'Ultimate Oscillator',
        group: 'Momentum',
        inputs: [
            {
                name: 'optInTimePeriod1',
                label: 'First Period',
                component: InputNumber,
                default: 7
            },
            {
                name: 'optInTimePeriod2',
                label: 'Second Period',
                component: InputNumber,
                default: 14
            },
            {
                name: 'optInTimePeriod3',
                label: 'Third Period',
                component: InputNumber,
                default: 28
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },

    WILLR: {
        name: 'Williams %R',
        group: 'Momentum',
        inputs: [
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                component: InputNumber,
                default: 14
            }
        ],
        outputs: [
            {
                name: 'outReal',
                label: 'Signal'
            }
        ]
    },

    DONCHIANCHANNEL: {
        name: 'Donchian Channel',
        group: 'Overlap',
        defaults: {},
        inputs: [
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                component: InputNumber,
                default: 20
            }
        ],
        outputs: [
            {
                name: 'upperBand',
                label: 'Upper Band'
            },
            {
                name: 'centerLine',
                label: 'Center Line'
            },
            {
                name: 'lowerBand',
                label: 'Lower Band'
            }
        ]
    },
    KELTNERCHANNEL: {
        name: 'Keltner Channel',
        group: 'Overlap',
        inputs: [
            {
                name: 'optInTimePeriod',
                label: 'Time Period (Length)',
                component: InputNumber,
                default: 20
            },
            {
                name: 'multiplier',
                label: 'Multiplier',
                component: InputNumber,
                default: 1
            },
            {
                name: 'smoothLen',
                label: 'Smooth Length',
                component: InputNumber,
                default: 10
            }
        ],
        outputs: [
            {
                name: 'upperBand',
                label: 'Upper Band'
            },
            {
                name: 'centerLine',
                label: 'Center Line'
            },
            {
                name: 'lowerBand',
                label: 'Lower Band'
            }
        ]
    },

    CDL2CROWS: {
        name: 'Two Crows',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDL3BLACKCROWS: {
        name: 'Three Black Crows',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDL3LINESTRIKE: {
        name: 'Three-Line Strike',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDL3OUTSIDE: {
        name: 'Three Outside Up/Down',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDL3STARSINSOUTH: {
        name: 'Three Stars In The South',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDL3WHITESOLDIERS: {
        name: 'Three Advancing White Soldiers',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLABANDONEDBABY: {
        name: 'Abandoned Baby',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLADVANCEBLOCK: {
        name: 'Advance Block',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLBELTHOLD: {
        name: 'Belt-hold',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLBREAKAWAY: {
        name: 'Breakaway',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: []
    },
    CDLCLOSINGMARUBOZU: {
        name: 'Closing Marubozu',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLCONCEALBABYSWALL: {
        name: 'Concealing Baby Swallow',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLCOUNTERATTACK: {
        name: 'Counterattack',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLDARKCLOUDCOVER: {
        name: 'Dark Cloud Cover',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLDOJI: {
        name: 'Doji',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLDOJISTAR: {
        name: 'Doji Star',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLDRAGONFLYDOJI: {
        name: 'Dragonfly Doji',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLENGULFING: {
        name: 'Engulfing Pattern',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLEVENINGDOJISTAR: {
        name: 'Evening Doji Star',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLEVENINGSTAR: {
        name: 'Evening Star',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLGAPSIDESIDEWHITE: {
        name: 'Up/Down-gap side-by-side white lines',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLGRAVESTONEDOJI: {
        name: 'Gravestone Doji',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLHAMMER: {
        name: 'Hammer',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLHANGINGMAN: {
        name: 'Hanging Man',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLHARAMI: {
        name: 'Harami Pattern',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLHARAMICROSS: {
        name: 'Harami Cross Pattern',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLHIGHWAVE: {
        name: 'High-Wave Candle',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLHIKKAKE: {
        name: 'Hikkake Pattern',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLHOMINGPIGEON: {
        name: 'Homing Pigeon',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLIDENTICAL3CROWS: {
        name: 'Identical Three Crows',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLINNECK: {
        name: 'In-Neck Pattern',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLINVERTEDHAMMER: {
        name: 'Inverted Hammer',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLKICKING: {
        name: 'Kicking',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLKICKINGBYLENGTH: {
        name: 'Kicking by length',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: []
    },
    CDLLADDERBOTTOM: {
        name: 'Ladder Bottom',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLLONGLEGGEDDOJI: {
        name: 'Long Legged Doji',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLLONGLINE: {
        name: 'Long Line Candle',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLMARUBOZU: {
        name: 'Marubozu',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLMATCHINGLOW: {
        name: 'Matching Low',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLMATHOLD: {
        name: 'Mat Hold',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLMORNINGDOJISTAR: {
        name: 'Morning Doji Star',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLMORNINGSTAR: {
        name: 'Morning Star',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLONNECK: {
        name: 'On-Neck Pattern',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLPIERCING: {
        name: 'Piercing Pattern',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLRICKSHAWMAN: {
        name: 'Rickshaw Man',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLRISEFALL3METHODS: {
        name: 'Rising/Falling Three Methods',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLSEPARATINGLINES: {
        name: 'Separating Lines',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLSHOOTINGSTAR: {
        name: 'Shooting Star',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLSHORTLINE: {
        name: 'Short Line Candle',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLSPINNINGTOP: {
        name: 'Spinning Top',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLSTALLEDPATTERN: {
        name: 'Stalled Pattern',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLSTICKSANDWICH: {
        name: 'Stick Sandwich',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLTAKURI: {
        name: 'Takuri',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLTASUKIGAP: {
        name: 'Tasuki Gap',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLTHRUSTING: {
        name: 'Thrusting Pattern',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLTRISTAR: {
        name: 'Tristar Pattern',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLUNIQUE3RIVER: {
        name: 'Unique 3 River',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLUPSIDEGAP2CROWS: {
        name: 'Upside Gap Two Crows',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    },
    CDLXSIDEGAP3METHODS: {
        name: 'Upside/Downside Gap Three Methods',
        group: 'Pattern Recognition',
        isCandlePattern: true,
        inputs: [],
        outputs: [
            {
                name: 'outInteger',
                label: 'Signal'
            }
        ]
    }
};



// WEBPACK FOOTER //
// ./src/Account/Strategies/Shared/IndicatorManager/indicators.js